import * as types from '../actions/types';

const initialState = {
    wait: false,
    data: [],
    error: null,
};

export default function (state=initialState, {type, payload}) {
    switch (type) {
        // list
        case types.GET_ALL_NONCUSTOMERS_WAIT:
            return {
                ...state,
                wait: true,
            };
        case types.GET_ALL_NONCUSTOMERS_SUCCESS:
            return {
                ...state,
                wait: false,
                data: [...payload],
            };
        case types.GET_ALL_NONCUSTOMERS_ERROR:
            return {
                ...state,
                wait: false,
                data: [],
            };
        default:
            return state;
    }
}
